import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Transaction } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import CapitalVariationOperationTableRow from './CapitalVariationOperationTableRow';

const CapitalVariationOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const transactions = (data.operation?.transactions as Transaction[]) || [];

  const hasData = transactions.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {transactions?.map((transaction: Transaction, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr className="nk-tb-item" key={`capital-variation-row-${index}`}>
              <CapitalVariationOperationTableRow
                index={index}
                transaction={transaction}
              />
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default CapitalVariationOperationTableBody;
